import { createFileRoute, useNavigate } from '@tanstack/react-router'
import z from 'zod'
import DaySchedule from '@/components/organisms/day-schedule'

const searchSchema = z.object({
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
})

export const Route = createFileRoute('/_authenticated/schedule/day-schedule/$userId')({
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { userId } = Route.useParams()
  const { date } = Route.useSearch()
  const navigate = useNavigate()

  console.log(userId)
  console.log('hello')

  return <DaySchedule userId={userId} date={date} onClose={() => navigate({ to: '/schedule' })} />
}
